"use strict";
import { __exports as n } from "./index.es511.js";
import { __require as l } from "./index.es512.js";
import { __require as d } from "./index.es513.js";
var t;
function R() {
  return t ? n : (t = 1, (function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    });
    function o(u, e) {
      for (var r in e) Object.defineProperty(u, r, {
        enumerable: !0,
        get: e[r]
      });
    }
    o(i, {
      normalizeAppPath: function() {
        return a;
      },
      normalizeRscURL: function() {
        return p;
      }
    });
    const s = l(), f = d();
    function a(u) {
      return (0, s.ensureLeadingSlash)(u.split("/").reduce((e, r, c, _) => !r || (0, f.isGroupSegment)(r) || r[0] === "@" || (r === "page" || r === "route") && c === _.length - 1 ? e : e + "/" + r, ""));
    }
    function p(u) {
      return u.replace(
        /\.rsc($|\?)/,
        // $1 ensures `?` is preserved
        "$1"
      );
    }
  })(n), n);
}
export {
  R as __require
};
//# sourceMappingURL=index.es486.js.map
